<script setup lang="ts">
import AppSvgIcon from '../appSvgIcon/AppSvgIcon.vue';
import AppLinkButton from '../appLinkButton/AppLinkButton.vue';
import AppFlicker from '../appLoaders/appFlicker/AppFlicker.vue';

import type {
  AppPlaceholderAction,
  AppPlaceholderIconProperties,
} from './AppPlaceholder.model';
import AppPlaceholderLayout from './AppPlaceholderLayout.vue';

interface AppBasePlaceholderProps {
  title: string;
  description: string;
  isSmallDevice: boolean;
  iconProperties: AppPlaceholderIconProperties;
  actions?: AppPlaceholderAction[];
  isLoading?: boolean;
  isPrintMode?: boolean;
}
const props = defineProps<AppBasePlaceholderProps>();

interface AppBasePlaceholderEmits {
  (event: 'action-clicked', action: string): void;
}
const emit = defineEmits<AppBasePlaceholderEmits>();
</script>

<template>
  <AppPlaceholderLayout
    :description="props.description"
    :title="props.title"
    :is-loading="props.isLoading"
    :is-small-device="props.isSmallDevice"
    :is-print-mode="props.isPrintMode"
  >
    <template #left-content>
      <AppSvgIcon
        :name="props.iconProperties.name"
        :size="props.isSmallDevice ? '24' : '36'"
        :color="props.iconProperties.color"
        :aria-label="props.iconProperties.name"
      />
    </template>
    <template #actions>
      <template v-for="action in props.actions" :key="action.eventType">
        <AppFlicker
          v-if="props.isLoading"
          width="spacing-64"
          :height="props.isSmallDevice ? 'font-size-s' : 'font-size-m'"
          :margin="{ ySpacing: 'spacing-4' }"
        />
        <AppLinkButton
          v-else
          :text="action.textToDisplay"
          :size="isSmallDevice ? 's' : 'm'"
          font="secondary"
          bold
          underline
          :right-icon="action.rightIconName"
          icon-size="18"
          @click="emit('action-clicked', action.eventType)"
        />
      </template>
      <slot name="actions" />
    </template>
  </AppPlaceholderLayout>
</template>
